import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { deleteBooking } from '../../../data/api';
import toast from '../../Toast';

type BookingProps = {
  scheduleId: string;
  booked: boolean;
  successCallback?: Function;
  [x: string]: any;
};

export default function Booking({ scheduleId, booked, successCallback, ...rest }: BookingProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = async (event: any) => {
    event.preventDefault();
    let result = null;
    setLoading(true);

    result = await deleteBooking(scheduleId);

    if (result?.success) {
      successCallback && successCallback();
      toast.success(result.message);
    } else {
      toast.error(result?.message);
    }

    setLoading(false);
  };

  const disabled = loading || scheduleId === '';

  return (
    <div className="d-flex flex-column">
      {booked
        ? <Button
          type="button"
          size="lg"
          variant="danger"
          disabled={disabled}
          onClick={submitHandler}
        >
          {loading && <Spinner animation="border" variant="light" size="sm" className="ms-2" />}
          Cancel Booking
        </Button>
        : <Button
          type="button"
          size="lg"
          variant="success"
          disabled={disabled}
          onClick={() => navigate(`/claim/${scheduleId}`)}
        >Book</Button>}
    </div>
  );
}